<template>
  <div class="mask" @click.stop>
    <div class="content">
        <p class="title">求职意向反馈</p>
        <input v-model="feedInfo" type="text" placeholder="请输入您的求职意向">
        <div class="buttons">
           <p @click="cancle">取消</p>
           <p class="confirm" @click="confirm">确定</p>
        </div>
    </div>
  </div>
</template>
<script>
  import {get_tUser} from '../../assets/js/util'
  import api from '@/api'
  export default{
    name:'Feedback',
    data(){
      return {
        feedInfo:'',
      }
    },
    methods:{
      cancle(){
        this.$emit('closeFeed')
      },
      async confirm(){
        if(this.feedInfo === '') return
        let res = await api.account.feedbackSubmit({
          feedback_platform: 'pc_vue',
          feedback_type: 6,
          content: this.feedInfo,
          token: get_tUser().c_t
        })
        if(res.code === 1000){
		  this.$message.success('感谢您的反馈')
          this.cancle()
        }
      }
    }
  }
</script>
<style scoped lang="scss">
.mask{
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background: rgba($color: #000000, $alpha: 0.5);
  .content{
    width: 420px;
    height: 179px;
    border-radius: 4px;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10000;
    margin:  auto;
    padding: 24px 32px;
    box-sizing: border-box;
    .title{
      font-size: 17px;
      font-weight: 500;
      color: #404040;
      line-height: 23px;
    }
    input{
      outline: none;
      border-radius: 4px;
      border: 1px solid #CFCFCF;
      width: 100%;
      height: 36px;
      padding: 8px 15px;
      box-sizing: border-box;
      margin-top: 13px;
    }
    .buttons{
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-end;
      align-items: center;
      margin-top: 30px;
      p{
        width: 77px;
        height: 32px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
        color: #404040;
        font-size: 13px;
        border-radius: 2px;
        border: 1px solid #CFCFCF;
        margin-left: 15px;
        box-sizing: border-box;
      }
      .confirm{
        background: #FF6644;
        color: #fff;
        border: none;
        border: 1px solid #FF6644;
      }
    }
  }
}
</style>